import React, { useState, useEffect,useCallback } from 'react'
import RequestAddEdit from './RequestAddEdit';
import { GENERIC_REQUEST, LIST, getApiPath } from '../../api/ApiConst';
import TableFilter from '../constants/TableFilter';
import { useClient } from '../../config/ClientProvider';

const RequestList = () => {
    const { selectedClient } = useClient();
    const [requestDrawCount, setRequestDrawCount] = useState(0);
    const [showAddModel, setShowAddModel] = useState(false);
    let rObj = {
        commandId: "",
        name: "",
        description: "",
        type: "",
        cashed: false,
        pageable: false,
        ipBounded: false,
        ipAddressList: [],
        authenticated: false
    };

    const toggleAddModel = () => {
        setShowAddModel(prev => !prev)
    }

    // Create New Request Data
    const handleCreateRequestData = () => {
        toggleAddModel();
    }

    // Refresh Table
    const refreshRequestTable = () => {
        setRequestDrawCount((pre) => (pre + 1));
    }

    const getRequestTableView = useCallback(() => {
        return (
            <>
                <div className='row justify-content-end'>
                    <div className="col-12 px-0">
                        <div className='card mb-0'>
                            <div className="card-body d-flex justify-content-end" style={{ textAlign: "right" }}>
                                <button className="btn btn-primary"
                                    onClick={handleCreateRequestData}> Create New</button>
                            </div>
                            <TableFilter
                                tableName="request"
                                tableUrl={getApiPath(GENERIC_REQUEST, LIST)}
                                paginationStatus={true}
                                drawCount={requestDrawCount}
                                refreshTableData={refreshRequestTable}
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    },
        [requestDrawCount],
    );

    // useEffect to listen for selectedClient changes
	useEffect(() => {
		if (selectedClient) {
			refreshRequestTable();
		}
	}, [selectedClient]);

    return (
        <>
            {getRequestTableView()}
            {
                <RequestAddEdit
                    show={showAddModel}
                    close={toggleAddModel}
                    successCallBack={refreshRequestTable}
                    object={rObj}
                />
            }
        </>
    )
}

export default RequestList